import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {BaseComponent} from '../common/common-components';
import {DictionaryService} from "../services/dictionary-service";
import {MessageService} from "../services/message-service";
import {ModalService} from "../services/modal-service";
import { HarmonogramService } from "./harmonogram-service";
import { BankAccountService } from "../accounts/bank-account-service";
import { UserService } from "../user/user-service";
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';

let _ : any = require("lodash");

@Component({
    selector: 'dk-harmonogram-list',
    template: require('./harmonogram-list.html'),
    entryComponents: [],
    providers: [DictionaryService, HarmonogramService, BankAccountService, UserService]
})

export class HarmonogramListComponent extends BaseComponent implements OnInit {
    items: any[];
    public isActive: boolean = true;
    public personalData: boolean = false;
    
    constructor(
        private harmonogramService: HarmonogramService,
        private bankAccountService: BankAccountService,
        private modalService: ModalService,
        private messageService: MessageService,
        private userService: UserService) {
        super();
    }

    public ngOnInit() {
        this.bankAccountService.isAccountActive().subscribe(result => {
            if (result == false) {
                this.isActive = false;
            }
        });

        this.userService.accountInfo().subscribe(result => {
            this.personalData = result;
        });

        this.load();
    }

    load() {
        this.harmonogramService.list().subscribe(items => {
            this.items = items;
        });
    }

    switchState(item) {
        this.harmonogramService.changeStatus(item.HarmonogramID, item.Enabled ? 0 : 1)
            .pipe(
                catchError((err: any, caught: Observable<boolean>) => {
                    this.messageService.errorByMessageId(err.messageId);
                    return null;
                })
            )
            .subscribe(() => {
                item.Enabled = item.Enabled ? 0 : 1;
            });
    }

    showDetails(item) {
        item.ShowDetails = item.ShowDetails ? false : true;
    }

    delete(item) {
        this.modalService.confirm().then(result => {
            if (result) {
                this.harmonogramService.delete(item.HarmonogramID).subscribe(() => {
                    this.load();
                });
            }
        });
    }
}
